import { Observer } from 'src/app/common/shared/observer.interface';
import { ValueTypes } from '../custom.types';
import { EventTypes } from './observer.enum';

export abstract class Subject {
  protected observers: Observer[] = [];

  public attach(observer: Observer): void {
    const exist: boolean = this.observers.includes(observer);
    if (!exist) {
      this.observers.push(observer);
    }
  }

  public detach(observer: Observer): void {
    const index: number = this.observers.indexOf(observer);
    if (index !== -1) {
      this.observers.splice(index, 1);
    }
  }

  public destroy(): void {
    Array.from(this.observers).forEach((observer: Observer) => {
      this.detach(observer);
    });
  }

  public abstract notify(type: EventTypes, ...data: ValueTypes[]): void;
}
